import { FormInitializerReturnType, stringSchema } from 'src/Configuration/validation'
import { CreateCategoryForm, CreateCategoryFormValues } from '../components'
import { boolean, object } from 'yup'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DownloadsCategoryModel, DownloadsParent } from '../models'

const MIN_STRING_LENGTH = 3
const MAX_STRING_LENGTH = 60

/**
 *  Initializes the form for editing the category of a download item
 * @param item DownloadDto
 * @param parent DownloadDto
 * @returns initialValues and validationSchema for category editor form
 */
export const useCategoryEditorFormInitializer = (
  item?: DownloadsCategoryModel,
  parent?: DownloadsParent
): FormInitializerReturnType<CreateCategoryForm, CreateCategoryFormValues> => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const initialValues: CreateCategoryFormValues = {
    path: parent?.path ?? 'Root',
    nameDe: item?.nameLanguages?.de ?? '',
    nameEn: item?.nameLanguages?.en ?? '',
    nameFr: item?.nameLanguages?.fr ?? '',
    nameNl: item?.nameLanguages?.nl ?? '',
    nameXx: item?.nameLanguages?.xx ?? '',
    visibleToCustomer: item?.visibleToCustomer ?? false,
    visibleToInstaller: item?.visibleToInstaller ?? false,
  }

  const validationSchema = object().shape({
    visibleToCustomer: boolean().required(),
    visibleToInstaller: boolean().required(),
    isFirstLevel: boolean(),
    nameDe: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH, maxLength: MAX_STRING_LENGTH }).required().trim(),
    nameEn: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH, maxLength: MAX_STRING_LENGTH }).required().trim(),
    nameFr: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH, maxLength: MAX_STRING_LENGTH }).required().trim(),
    nameNl: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH, maxLength: MAX_STRING_LENGTH }).required().trim(),
    nameXx: stringSchemaWithTranslation({ minLength: MIN_STRING_LENGTH, maxLength: MAX_STRING_LENGTH }).trim(),
  })
  return { initialValues, validationSchema }
}
